import Vue from "vue";
/**
 * setting
 * @method setTag
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClose
 * event
 * @event sendCallbackClose
 */
export function ShippingModalController () {
    this.title = '';
    this.tag = '';
    this.page = '';
    this.isBack = false;
    this.busModal = new Vue();

    this.callbackClose = null;
    this.callbackSelected = null;
    this.callbackShowLoading = null;
    this.callbackHideLoading = null;
    this.callbackInternetError = null;

    //#region relate modal
    this.alertModal = null;
    this.confirmModal = null;
    this.loadingModal = null;
    this.setAlertModal = function (alertModal) {
        this.alertModal = alertModal;
    };
    this.setConfirmModal = function (confirmModal) {
        this.confirmModal = confirmModal;
    };
    this.setLoadingModal = function (loadingModal) {
        this.loadingModal = loadingModal;
    };
    //#endregion relate modal

    //#region setter
    this.setTitle = function (title) {
        this.title = title;
        return this;
    };
    this.setTag = function(tag) {
        this.tag = tag;
        return this;
    };
    this.setPage = function(page) {
        this.page = page;
        return this;
    };
    this.setBack = function(isBack) {
        this.isBack = isBack;
        return this;
    };
    this.clearModal = function() {
        this.title = '';
        this.tag = '';
        this.isBack = false;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            title: this.title,
            tag: this.tag,
            page: this.page,
            isBack: this.isBack,
        };
        this.busModal.$emit('show', config);
    };
    this.hide = function() {
        this.busModal.$emit('hide');
    };
    //#endregion method

    //#region event
    this.onClose = function(callback) {
        if (typeof callback == 'function') {
            this.callbackClose = callback;
        }
    };
    this.onInternetError = function(callback) {
        if (typeof callback == 'function') {
            this.callbackInternetError = callback;
        }
    };
    this.sendCallbackClose = function(data) {
        if (typeof this.callbackClose == 'function') {
            this.callbackClose(data);
        }
    };

    this.onSelected = function (callback) {
        if (typeof callback == 'function') {
            this.callbackSelected = callback;
        }
    };

    this.sendCallbackSelected = function(data) {
        if (typeof this.callbackSelected == 'function') {
            this.callbackSelected(data);
        }
    };

    this.sendCallbackInternetError = function(data) {
        if (typeof this.callbackInternetError == 'function') {
            this.callbackInternetError(data);
        }
    };
    //#endregion event
}
